export { default as DetailProduct } from './DetailProduct'

export { FakeLoading } from './FakeLoading'